#import "../common/graphql/SecureRowLevelsEntityFields.graphql"
#import "../common/graphql/ExtractionTypes.graphql"
query GetDocumentPoolCommonData($isDocumentUpload: Boolean) {
  companyBusinessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  tax1099T4Types {
    nodes {
      id
      tax1099T4Type
      abbreviation
    }
  }
  companyDepartments(orderBy: NAME_ASC) {
    nodes {
      id
      name
      _isDocSelectable
    }
  }
  companyUserGroups(orderBy: USER_GROUP_BY_USER_GROUP_ID__NAME_ASC) {
    nodes {
      id
      userGroupId
      userGroup {
        name
      }
    }
  }
  directoryTypes(
    filter: { isPoolSelectable: { equalTo: true } }
    orderBy: DESCRIPTION_ASC
  ) {
    nodes {
      id
      directory
      description
      isPoolSelectable
    }
  }
  documentPoolAvailableDocumentTypes(isDocumentUpload: $isDocumentUpload) {
    nodes {
      id
      documentType
      _isDefault
      isAccountingDocument
      isSigningRequired
      ...ExtractionTypes
    }
  }
  personalPoolAvailableDocumentTypes(isDocumentUpload: $isDocumentUpload) {
    nodes {
      id
      documentType
      _isDefault
      isAccountingDocument
      isSigningRequired
      ...ExtractionTypes
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  documentTypeUploads(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      documentType
    }
  }
}
